export const NAV_EXTERNALS = {
  cypressLocationReplace: (url) => {
    if ((window as any).cypressLocationReplace) {
      (window as any).cypressLocationReplace(url);
    }

    window.location.replace(url);
  },
};
